import { getTaskParam } from '@/services/api/api0';
import { proxy, useSnapshot } from '@umijs/max';
import { message } from 'antd';

export interface IVideoConfigStore {
  videoConfig: API.TaskParamResp;
  defaultVideoConfig: {
    picModel: string;
    videoModel: string;
    ratio: string;
    style: string;
  };
}

class VideoConfigHandler {
  timer?: NodeJS.Timeout;
  store: IVideoConfigStore;
  constructor() {
    this.store = proxy<IVideoConfigStore>({
      videoConfig: {
        picModel: [],
        videoModel: [],
        ratio: [],
        style: [],
      },

      get defaultVideoConfig() {
        const { picModel, videoModel, ratio, style } = this.videoConfig;
        return {
          picModel: picModel?.[0]?.value || '',
          videoModel: videoModel?.[0]?.value || '',
          ratio: ratio?.[0]?.value || '',
          style: style?.[0]?.value || '',
        };
      },
    });
  }
  setStore = (data: Partial<IVideoConfigStore>) => {
    Object.assign(this.store, data);
  };
  getVideoConfig = async () => {
    try {
      const res = await getTaskParam({ taskType: 'video' });
      if (res.code === '200') {
        this.setStore({
          videoConfig: res.data!,
        });
        return res.data;
      } else {
        message.error(res.message);
      }
    } catch {
      message.error('获取视频配置失败');
    }
  };
}
export const videoConfigHandler = new VideoConfigHandler();
export function useVideoConfig() {
  const { videoConfig, defaultVideoConfig } = useSnapshot(
    videoConfigHandler.store,
  );
  return {
    videoConfig,
    defaultVideoConfig,
  };
}
